<template>
  <div :class="!isDetail ? 'wrapper sidebar-collapsed' : ''">
    <portal-target
      name="layout-main"
      class="layout-main panel-scroll-full">
      <div class="panel-detail panel-fixed panel-with-actions">
        <div class="panel-header">
          <h1 class="page-header">
            {{ $t('Search in registry')}}
          </h1>
          <ol class="breadcrumb pull-right">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'dashboard'}">
                {{"Dashboard"}}
              </router-link>
            </li>
            <li class="breadcrumb-item">
              {{ "Search in registry" | translate }}
            </li>
          </ol>
        </div>
        <advanced-search
          v-show="true"
          :fields="searchFields"
          :reset="false"
          :disable-empty-search="true"
          @search="searchData"
          @reset="removeFilters"
          @active="activeFilters = $event"
        />
        <organization-list v-if="showOrgList" :search-string="searchString" :category-group-id="categoryGroupId"></organization-list>
        <contact-list v-if="showContactList" :search-string="searchString" :category-group-id="categoryGroupId"></contact-list>
      </div>
    </portal-target>
  </div>
</template>

<script>
import { axiosThux } from '@/axiosThux'
import AdvancedSearch from '@/components/advanced-search/AdvancedSearch'
import OrganizationList from './organization/OrganizationList'
import ContactList from './contact/ContactList'
export default {
  name: 'GenericSearchPage',
  props: {
    isDetail: { default: false }
  },
  components: {
    'organization-list': OrganizationList,
    'contact-list': ContactList,
    'advanced-search': AdvancedSearch
  },
  data () {
    return {
      form: { searchString: undefined },
      searchString: undefined,
      categoryGroupId: undefined,
      categoryGroupOptions: [],
      showOrgList: false,
      showContactList: false
    }
  },
  computed: {
    searchFields () {
      return [
        { key: 'name', placeholder: this.$t('Search by organization name or contact last name'), type: 'text', col: 12 },
        { key: 'category_group', placeholder: this.$t('Category'), type: 'select', options: this.categoryGroupOptions, col: 12 }
      ]
    }
  },
  created () {
    const profile = this.$store.getters['auth/profile'] || 'generic'
    axiosThux.get(`/api/v1/organization/${profile}/organization-group/?no_page=no_page&order_by=name`)
      .then(response => {
        const groups = Array.isArray(response.data) ? response.data : (response.data.results || [])
        this.categoryGroupOptions = groups.map(g => ({ value: g.id, text: g.name }))
      })
  },
  methods: {
    searchData (filters) {
      this.$set(this, 'showOrgList', true)
      this.$set(this, 'showContactList', true)
      this.$set(this, 'searchString', filters.name)
      this.$set(this, 'categoryGroupId', filters.category_group || undefined)
    },
    removeFilters () {
      this.$set(this, 'showOrgList', false)
      this.$set(this, 'showContactList', false)
      this.$set(this, 'searchString', undefined)
      this.$set(this, 'categoryGroupId', undefined)
    }
  }
}
</script>
